import { render, staticRenderFns } from "./MockQuestion.vue?vue&type=template&id=c150c608&scoped=true"
import script from "./MockQuestion.vue?vue&type=script&lang=js"
export * from "./MockQuestion.vue?vue&type=script&lang=js"
import style0 from "./MockQuestion.vue?vue&type=style&index=0&id=c150c608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c150c608",
  null
  
)

export default component.exports